import Api, { baseURL, requestOptionsGET } from "../api";
import newFetch from "../utils/newFetch";

const state = {
  states: [],
  cities: [],
};

const getters = {
  getStates: (state) => state.states,
  getCities: (state) => state.cities,
};

const mutations = {
  setStates(state, payload) {
    state.states = payload;
  },
  setCities(state, payload) {
    state.cities = payload;
  },
};

const actions = {
  fetchStates(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStates,
        requestOptionsGET(localStorage.getItem("accessToken"))
      )
        .then((data) => {
          context.commit("setStates", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchCities(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getCities + id,
        requestOptionsGET(localStorage.getItem("accessToken"))
      )
        .then((data) => {
          context.commit("setCities", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
